// Business Configuration
export const BUSINESS_CONFIG = {
  // WhatsApp phone number (include country code, no + sign)
  // Format: country code + phone number (e.g., "18095551234" for +1-809-555-1234)
  whatsappPhone: "13052184930", // 🔄 Updated with your actual WhatsApp number (US)
  
  // Business information
  businessName: "Roke Car Sales",
  businessEmail: "contact@rokecar.com", // 🔄 CHANGE THIS TO YOUR ACTUAL EMAIL
  location: "Florida, United States",
  tagline: "Quality Used Cars in Florida",
  
  // SEO Keywords for Florida car dealership
  seoKeywords: [
    "used cars Florida",
    "pre-owned vehicles Florida", 
    "quality used cars",
    "car dealership Florida",
    "affordable cars Florida",
    "reliable vehicles",
    "car sales Florida",
    "auto dealer Florida",
    "certified pre-owned",
    "Florida car lot"
  ],
  
  // Contact messages templates (you can customize these)
  messages: {
    interested: "Hi! I'm interested in this car:",
    testDrive: "Hi! I would like to schedule a test drive for:",
    generalInquiry: "Hi! I have a question about one of your cars:"
  }
};

// Helper function to create WhatsApp URL
export const createWhatsAppUrl = (message: string): string => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${BUSINESS_CONFIG.whatsappPhone}?text=${encodedMessage}`;
};

// Helper function to format car info for messages
export const formatCarInfo = (car: { year: number; make: string; model: string; price: number }): string => {
  const price = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(car.price);
  
  return `${car.year} ${car.make} ${car.model} - ${price}`;
};